import React, { useState } from 'react';
import { X } from 'lucide-react';
import { fmtDate } from './helpers';

export default function UpdateModal({ plan, onClose, onSave }) {
  const [form, setForm] = useState({
    completed_quantity: plan.completed_quantity || 0,
    shipped_quantity: plan.shipped_quantity || 0,
    missing_items: plan.missing_items || '',
    notes: plan.notes || '',
    set_numbers: plan.set_numbers || '',
  });
  const unitLabel = plan.planning_unit === 'set' ? 'sets' : plan.planning_unit === 'seat' ? 'seats' : 'units';

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" data-testid="update-plan-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-bold text-slate-800">Update Production</h3>
            <p className="text-xs text-slate-500">{plan.material_description || plan.project_name} - {fmtDate(plan.date)}</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="w-5 h-5" /></button>
        </div>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-slate-600">Completed {unitLabel} (of {plan.planned_quantity})</label>
              <input type="number" min="0" value={form.completed_quantity}
                onChange={e => setForm(f => ({ ...f, completed_quantity: parseInt(e.target.value) || 0 }))}
                className="w-full border rounded-lg px-3 py-2 text-sm mt-1" data-testid="update-completed-input" />
            </div>
            <div>
              <label className="text-xs font-medium text-slate-600">Shipped {unitLabel}</label>
              <input type="number" min="0" value={form.shipped_quantity}
                onChange={e => setForm(f => ({ ...f, shipped_quantity: parseInt(e.target.value) || 0 }))}
                className="w-full border rounded-lg px-3 py-2 text-sm mt-1" data-testid="update-shipped-input" />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600">Missing Items / Defects</label>
            <input type="text" value={form.missing_items} onChange={e => setForm(f => ({ ...f, missing_items: e.target.value }))}
              className="w-full border rounded-lg px-3 py-2 text-sm mt-1" data-testid="update-missing-input" />
          </div>
          <div>
            <label className="text-xs font-bold text-blue-700">Set Numbers</label>
            <input type="text" value={form.set_numbers} onChange={e => setForm(f => ({ ...f, set_numbers: e.target.value }))}
              placeholder="e.g. Set#47, Set#48-50"
              className="w-full border border-blue-200 rounded-lg px-3 py-2 text-sm mt-1 bg-blue-50/30 focus:ring-2 focus:ring-blue-400 focus:outline-none" data-testid="update-set-numbers-input" />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600">Notes</label>
            <textarea value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))}
              className="w-full border rounded-lg px-3 py-2 text-sm mt-1" rows={2} data-testid="update-notes-input" />
          </div>
          <div className="bg-slate-50 rounded-lg p-3">
            <div className="flex justify-between text-xs text-slate-600 mb-1">
              <span>Progress</span>
              <span className="font-bold">{plan.planned_quantity > 0 ? Math.round((form.completed_quantity / plan.planned_quantity) * 100) : 0}%</span>
            </div>
            <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
              <div className={`h-full rounded-full ${form.completed_quantity >= plan.planned_quantity ? 'bg-emerald-500' : 'bg-amber-500'}`}
                style={{ width: `${Math.min((form.completed_quantity / (plan.planned_quantity || 1)) * 100, 100)}%` }} />
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button onClick={onClose} className="px-4 py-2 text-sm text-slate-600 hover:bg-slate-100 rounded-lg">Cancel</button>
            <button onClick={() => onSave(plan.id, form)} className="px-4 py-2 text-sm bg-slate-800 text-white rounded-lg hover:bg-slate-900" data-testid="update-save-btn">Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}
